import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface TsrSchool {
  rank: number;
  name: string;
  loc: string;
  alevel: number;
  gcse: number;
  gender: string;
}

interface TsrTop10School extends TsrSchool {
  change: string;
  changeText: string;
  desc: string;
  guide: string;
}

@Component({
  selector: 'app-private-schools',
  imports: [CommonModule, FormsModule],
  templateUrl: './private-schools.component.html',
  styleUrl: './private-schools.component.css',
})
export class PrivateSchoolsComponent {
   // ===== full 1-100 ranking =====
  tsrSchools: TsrSchool[] = [
    { rank: 1, name: 'St Paul\u2019s School', loc: 'London', alevel: 98.2, gcse: 97.6, gender: 'boys' },
    { rank: 2, name: 'Brighton College', loc: 'Brighton', alevel: 97.9, gcse: 98, gender: 'mixed' },
    { rank: 3, name: 'North London Collegiate School', loc: 'London', alevel: 96.6, gcse: 99.2, gender: 'girls' },
    { rank: 4, name: 'Godolphin and Latymer School', loc: 'London', alevel: 97.5, gcse: 96.9, gender: 'girls' },
    { rank: 5, name: 'Guildford High School', loc: 'Guildford', alevel: 97.3, gcse: 96.7, gender: 'girls' },
    { rank: 6, name: 'St Paul\u2019s Girls\u2019 School', loc: 'London', alevel: 95.6, gcse: 99.5, gender: 'girls' },
    { rank: 7, name: 'King\u2019s College School, Wimbledon', loc: 'London', alevel: 96.2, gcse: 98.2, gender: 'mixed' },
    { rank: 8, name: 'Westminster School', loc: 'London', alevel: 96.3, gcse: 97.6, gender: 'mixed' },
    { rank: 9, name: 'City of London School for Girls', loc: 'London', alevel: 95.7, gcse: 95.4, gender: 'girls' },
    { rank: 10, name: 'Latymer Upper School', loc: 'London', alevel: 95.1, gcse: 96.5, gender: 'mixed' },
    { rank: 11, name: 'King Edward VI High School for Girls', loc: 'Birmingham', alevel: 94.9, gcse: 96.6, gender: 'girls' },
    { rank: 12, name: 'Lady Eleanor Holles', loc: 'London', alevel: 95.9, gcse: 93.6, gender: 'girls' },
    { rank: 13, name: 'Alleyn\u2019s School', loc: 'London', alevel: 94.7, gcse: 94.8, gender: 'mixed' },
    { rank: 14, name: 'Eton College', loc: 'Windsor', alevel: 95, gcse: 94, gender: 'boys' },
    { rank: 15, name: 'Sevenoaks School', loc: 'Sevenoaks', alevel: 97.4, gcse: 88.7, gender: 'mixed' },
    { rank: 16, name: 'South Hampstead High School GDST', loc: 'London', alevel: 95.2, gcse: 92.2, gender: 'girls' },
    { rank: 17, name: 'City of London School', loc: 'London', alevel: 93.2, gcse: 95.5, gender: 'boys' },
    { rank: 18, name: 'Wycombe Abbey', loc: 'High Wycombe', alevel: 92.4, gcse: 96.7, gender: 'girls' },
    { rank: 19, name: 'Highgate School', loc: 'London', alevel: 92.7, gcse: 95.7, gender: 'mixed' },
    { rank: 20, name: 'Magdalen College School', loc: 'Oxford', alevel: 93.2, gcse: 94.1, gender: 'mixed' },
    { rank: 21, name: 'Queen Ethelburga\u2019s College', loc: 'York', alevel: 94.5, gcse: 90.3, gender: 'mixed' },
    { rank: 22, name: 'Royal Grammar School, Guildford', loc: 'Guildford', alevel: 95.2, gcse: 88.6, gender: 'boys' },
    { rank: 23, name: 'Putney High School GDST', loc: 'London', alevel: 93.4, gcse: 91.8, gender: 'girls' },
    { rank: 23, name: 'Hampton School', loc: 'London', alevel: 91.5, gcse: 95.8, gender: 'boys' },
    { rank: 25, name: 'University College School', loc: 'London', alevel: 93.6, gcse: 91.3, gender: 'mixed' },
    { rank: 26, name: 'Winchester College', loc: 'Winchester', alevel: 92.4, gcse: 93.5, gender: 'mixed' },
    { rank: 26, name: 'The Perse School', loc: 'Cambridge', alevel: 93.9, gcse: 90.4, gender: 'mixed' },
    { rank: 28, name: 'Tonbridge School', loc: 'Tonbridge', alevel: 92.5, gcse: 92.6, gender: 'boys' },
    { rank: 29, name: 'Reigate Grammar School', loc: 'Reigate', alevel: 93.9, gcse: 89.7, gender: 'mixed' },
    { rank: 30, name: 'Kingston Grammar School', loc: 'Kingston upon Thames', alevel: 92.7, gcse: 91.6, gender: 'mixed' },
    { rank: 31, name: 'Concord College', loc: 'Shrewsbury', alevel: 95.3, gcse: 86.2, gender: 'mixed' },
    { rank: 32, name: 'Trinity School, Croydon', loc: 'Croydon', alevel: 95, gcse: 86.1, gender: 'mixed' },
    { rank: 33, name: 'James Allen\u2019s Girls\u2019 School', loc: 'London', alevel: 92.7, gcse: 90.7, gender: 'girls' },
    { rank: 34, name: 'Notting Hill and Ealing High School GDST', loc: 'London', alevel: 91.4, gcse: 93.1, gender: 'girls' },
    { rank: 35, name: 'Withington Girls\u2019 School', loc: 'Manchester', alevel: 91.3, gcse: 92.9, gender: 'girls' },
    { rank: 36, name: 'Wimbledon High School GDST', loc: 'London', alevel: 94.6, gcse: 85.9, gender: 'girls' },
    { rank: 37, name: 'Bancroft\u2019s', loc: 'Woodford Green', alevel: 93.2, gcse: 88.3, gender: 'mixed' },
    { rank: 38, name: 'Caterham School', loc: 'Caterham', alevel: 91.4, gcse: 91.5, gender: 'mixed' },
    { rank: 38, name: 'The Manchester Grammar School', loc: 'Manchester', alevel: 93, gcse: 88.2, gender: 'boys' },
    { rank: 40, name: 'Cardiff Sixth Form College', loc: 'Cardiff', alevel: 99.6, gcse: 74.8, gender: 'mixed' },
    { rank: 41, name: 'King Edward\u2019s School, Birmingham', loc: 'Birmingham', alevel: 94.8, gcse: 83.8, gender: 'boys' },
    { rank: 42, name: 'Emanuel School', loc: 'London', alevel: 91.3, gcse: 90.9, gender: 'mixed' },
    { rank: 43, name: 'Oxford High School GDST', loc: 'Oxford', alevel: 89.3, gcse: 93.6, gender: 'girls' },
    { rank: 43, name: 'Eltham College', loc: 'London', alevel: 91.9, gcse: 88.5, gender: 'mixed' },
    { rank: 45, name: 'Channing School', loc: 'London', alevel: 95.1, gcse: 81.7, gender: 'girls' },
    { rank: 46, name: 'Dulwich College', loc: 'London', alevel: 89.1, gcse: 93.5, gender: 'boys' },
    { rank: 47, name: 'Colfe\u2019s School', loc: 'London', alevel: 95.3, gcse: 80.1, gender: 'mixed' },
    { rank: 48, name: 'Wellington College', loc: 'Crowthorne', alevel: 91.6, gcse: 86.7, gender: 'mixed' },
    { rank: 49, name: 'Nottingham High School', loc: 'Nottingham', alevel: 92.4, gcse: 84.9, gender: 'mixed' },
    { rank: 50, name: 'Surbiton High School', loc: 'Kingston upon Thames', alevel: 91.8, gcse: 85.5, gender: 'girls' },
    { rank: 51, name: 'St Albans High School for Girls', loc: 'St Albans', alevel: 92, gcse: 85, gender: 'girls' },
    { rank: 52, name: 'Epsom College', loc: 'Epsom', alevel: 90.6, gcse: 87.1, gender: 'mixed' },
    { rank: 53, name: 'Whitgift School', loc: 'South Croydon', alevel: 90.1, gcse: 87.2, gender: 'boys' },
    { rank: 54, name: 'St Helen and St Katharine', loc: 'Abingdon', alevel: 87.5, gcse: 92.1, gender: 'girls' },
    { rank: 55, name: 'Merchant Taylors\u2019 School, Northwood', loc: 'London', alevel: 89.3, gcse: 88.3, gender: 'boys' },
    { rank: 56, name: 'Westbourne School', loc: 'Penarth', alevel: 96.5, gcse: 73.1, gender: 'mixed' },
    { rank: 57, name: 'City of London Freemen\u2019s School', loc: 'Ashtead', alevel: 92.2, gcse: 81.5, gender: 'mixed' },
    { rank: 58, name: 'St Michael\u2019s School', loc: 'Llanelli', alevel: 93.5, gcse: 78.7, gender: 'mixed' },
    { rank: 59, name: 'Francis Holland School, Sloane Square', loc: 'London', alevel: 89, gcse: 87, gender: 'girls' },
    { rank: 60, name: 'Abingdon School', loc: 'Abingdon', alevel: 88.9, gcse: 87.1, gender: 'mixed' },
    { rank: 61, name: 'St Mary\u2019s School Ascot', loc: 'Ascot', alevel: 84.7, gcse: 94.1, gender: 'girls' },
    { rank: 62, name: 'Cheltenham Ladies\u2019 College', loc: 'Cheltenham', alevel: 87.3, gcse: 87.6, gender: 'girls' },
    { rank: 63, name: 'Harrow School', loc: 'Harrow on the Hill', alevel: 88.6, gcse: 84.3, gender: 'boys' },
    { rank: 64, name: 'St Catherine\u2019s, Bramley', loc: 'Guildford', alevel: 90.8, gcse: 79.6, gender: 'girls' },
    { rank: 65, name: 'St Swithun\u2019s School', loc: 'Winchester', alevel: 91.8, gcse: 77.4, gender: 'girls' },
    { rank: 66, name: 'Radley College', loc: 'Abingdon', alevel: 86.6, gcse: 86.5, gender: 'boys' },
    { rank: 67, name: 'The Leys', loc: 'Cambridge', alevel: 85.7, gcse: 86.1, gender: 'mixed' },
    { rank: 68, name: 'Sir William Perkins\u2019s School', loc: 'Chertsey', alevel: 86.1, gcse: 85, gender: 'girls' },
    { rank: 69, name: 'Sheffield Girls\u2019 GDST', loc: 'Sheffield', alevel: 87.9, gcse: 80.2, gender: 'girls' },
    { rank: 70, name: 'King Edward\u2019s School, Bath', loc: 'Bath', alevel: 89.7, gcse: 76.6, gender: 'mixed' },
    { rank: 71, name: 'St Dunstan\u2019s College', loc: 'London', alevel: 89.5, gcse: 76.7, gender: 'mixed' },
    { rank: 72, name: 'Ibstock Place School', loc: 'London', alevel: 86, gcse: 83.4, gender: 'mixed' },
    { rank: 73, name: 'Churcher\u2019s College', loc: 'Petersfield', alevel: 90.7, gcse: 73.6, gender: 'mixed' },
    { rank: 73, name: 'Hurstpierpoint College', loc: 'Hassocks', alevel: 88, gcse: 79, gender: 'mixed' },
    { rank: 75, name: 'St John\u2019s College, Cardiff', loc: 'Cardiff', alevel: 87.3, gcse: 80.2, gender: 'mixed' },
    { rank: 76, name: 'Benenden School', loc: 'Cranbrook', alevel: 87.9, gcse: 78.2, gender: 'girls' },
    { rank: 77, name: 'Haileybury', loc: 'Hertford', alevel: 85.8, gcse: 82.4, gender: 'mixed' },
    { rank: 77, name: 'Harrodian', loc: 'London', alevel: 88.4, gcse: 77.1, gender: 'mixed' },
    { rank: 79, name: 'The King\u2019s School, Chester', loc: 'Chester', alevel: 84.8, gcse: 83.6, gender: 'mixed' },
    { rank: 80, name: 'Queen\u2019s College, London', loc: 'London', alevel: 86.2, gcse: 80.8, gender: 'girls' },
    { rank: 81, name: 'Francis Holland School, Regent\u2019s Park', loc: 'London', alevel: 87, gcse: 79, gender: 'girls' },
    { rank: 81, name: 'Royal Grammar School, Newcastle', loc: 'Newcastle upon Tyne', alevel: 86.3, gcse: 80.3, gender: 'mixed' },
    { rank: 83, name: 'Oundle School', loc: 'Peterborough', alevel: 87.5, gcse: 77.6, gender: 'mixed' },
    { rank: 84, name: 'St Helen\u2019s School, Northwood', loc: 'London', alevel: 85.9, gcse: 80.4, gender: 'girls' },
    { rank: 85, name: 'St Augustine\u2019s Priory', loc: 'London', alevel: 93.5, gcse: 64.2, gender: 'girls' },
    { rank: 86, name: 'Redmaids\u2019 High School', loc: 'Bristol', alevel: 88.6, gcse: 73.1, gender: 'girls' },
    { rank: 87, name: 'St Albans School', loc: 'St Albans', alevel: 84.6, gcse: 80.4, gender: 'mixed' },
    { rank: 88, name: 'The Cathedral School, Llandaff', loc: 'Cardiff', alevel: 89.8, gcse: 69.9, gender: 'mixed' },
    { rank: 89, name: 'Reading Blue Coat', loc: 'Sonning-on-Thames', alevel: 83.4, gcse: 81.9, gender: 'mixed' },
    { rank: 89, name: 'Immanuel College', loc: 'Bushey', alevel: 88.4, gcse: 71.9, gender: 'mixed' },
    { rank: 91, name: 'Manchester High School for Girls', loc: 'Manchester', alevel: 85.9, gcse: 76.9, gender: 'girls' },
    { rank: 92, name: 'The Abbey', loc: 'Reading', alevel: 83.9, gcse: 80.8, gender: 'girls' },
    { rank: 93, name: 'Solihull School', loc: 'Solihull', alevel: 84.4, gcse: 78.8, gender: 'mixed' },
    { rank: 93, name: 'The Maynard School', loc: 'Exeter', alevel: 86.1, gcse: 75.4, gender: 'girls' },
    { rank: 95, name: 'Downe House', loc: 'Thatcham', alevel: 83, gcse: 81, gender: 'girls' },
    { rank: 96, name: 'Bedford School', loc: 'Bedford', alevel: 86.3, gcse: 74.1, gender: 'boys' },
    { rank: 97, name: 'The Grammar School at Leeds', loc: 'Leeds', alevel: 87.4, gcse: 71.1, gender: 'mixed' },
    { rank: 98, name: 'Leicester Grammar School', loc: 'Leicester', alevel: 85.8, gcse: 74.2, gender: 'mixed' },
    { rank: 99, name: 'Croydon High School GDST', loc: 'South Croydon', alevel: 84, gcse: 77.5, gender: 'girls' },
    { rank: 100, name: 'Reed\u2019s School', loc: 'Surrey', alevel: 85, gcse: 75, gender: 'mixed' }
  ];

  // ===== Top 10 rich content =====
  tsrTop10: TsrTop10School[] = [
    { rank: 1, name: 'St Paul\u2019s School', loc: 'London', alevel: 98.2, gcse: 97.6, gender: 'boys', change: 'up', changeText: 'Up 1', desc: 'Known for its long academic tradition, St Paul\u2019s ranked first nationally in 2026, with exceptional results across science, mathematics and the humanities. The curriculum emphasises independence and critical thought.', guide: '11+ Guide' },
    { rank: 2, name: 'Brighton College', loc: 'Brighton', alevel: 97.9, gcse: 98, gender: 'mixed', change: 'up', changeText: 'Up 1', desc: 'Academic achievement sits alongside a strong co-curricular focus, with pupils benefiting from broad opportunities in music, drama and sport across both boarding and day places.', guide: '11+ Guide' },
    { rank: 3, name: 'North London Collegiate School', loc: 'Edgware', alevel: 96.6, gcse: 99.2, gender: 'girls', change: 'up', changeText: 'Up 4', desc: 'Climbing from 8th to 3rd, NLCS combines strong A-level and GCSE outcomes with a structured curriculum valuing independence, collaboration and diverse enrichment opportunities.', guide: '11+ Guide' },
    { rank: 4, name: 'Godolphin and Latymer School', loc: 'London', alevel: 97.5, gcse: 96.9, gender: 'girls', change: 'up', changeText: 'Up 2', desc: 'An independent day school for girls in Hammersmith, blending academic challenge with creative study and research opportunities across arts, languages and science.', guide: '11+ Guide' },
    { rank: 5, name: 'Guildford High School', loc: 'Surrey', alevel: 97.3, gcse: 96.7, gender: 'girls', change: 'up', changeText: 'Up 3', desc: 'GHS balances academic focus with a rich programme of co-curricular activity, from sport and music to the arts, supporting consistent pupil performance year after year.', guide: '11+ Guide' },
    { rank: 6, name: 'St Paul\u2019s Girls\u2019 School', loc: 'London', alevel: 95.6, gcse: 99.5, gender: 'girls', change: 'down', changeText: 'Down 5', desc: 'One of the UK\u2019s most selective independent schools since 1904, recognised for combining academic depth with creative and cultural studies at both A-level and GCSE.', guide: '11+ Guide' },
    { rank: 7, name: 'King\u2019s College School, Wimbledon', loc: 'London', alevel: 96.2, gcse: 98.2, gender: 'mixed', change: 'down', changeText: 'Down 4', desc: 'KCS maintains a reputation for consistent academic success, supported by excellent facilities and a curriculum combining rigour with music, debating and community outreach.', guide: '11+ Guide' },
    { rank: 8, name: 'Westminster School', loc: 'London', alevel: 96.3, gcse: 97.6, gender: 'mixed', change: 'down', changeText: 'Down 3', desc: 'Located beside Westminster Abbey, this historic co-ed school combines strong results with a curriculum built around debate, inquiry and analytical thinking.', guide: '11+ Guide' },
    { rank: 9, name: 'City of London School for Girls', loc: 'London', alevel: 95.7, gcse: 95.4, gender: 'girls', change: 'same', changeText: 'No change', desc: 'Based in the Barbican, CLSG combines high GCSE and A-level outcomes with a broad co-curricular programme that develops communication, confidence and creativity.', guide: '11+ Guide' },
    { rank: 10, name: 'Latymer Upper School', loc: 'Hammersmith, London', alevel: 95.1, gcse: 96.5, gender: 'mixed', change: 'new', changeText: 'New Entrant \u00b7 Up from 16th', desc: 'A prestigious co-ed school with a 400-year history, notable for the highest Oxford and Cambridge acceptance rates in the country and a strong arts and sports tradition.', guide: '11+ Guide' }
  ];

  tsrChangeIcon: { [key: string]: string } = { up: 'ti-trending-up', down: 'ti-trending-down', same: 'ti-minus', new: 'ti-sparkles' };
  tsrGenderIcon: { [key: string]: string } = { girls: 'ti-woman', boys: 'ti-man', mixed: 'ti-users' };

  tsrMarqueeItems: TsrSchool[] = [];

  // table state
  tsrSearch = '';
  tsrGender = 'all';
  tsrSortKey = 'rank';
  tsrSortDir = 1;
  tsrPage = 1;
  tsrPageSize = 20;
  tsrFilteredRows: TsrSchool[] = [];
  tsrPageRows: TsrSchool[] = [];
  tsrTotalPages = 1;
  tsrPageNumbers: number[] = [];

  tsrHeroStats = [
    { label: 'Schools Ranked', target: 100, decimals: 0, current: 0, suffix: '' },
    { label: 'Top A-Level Score', target: 99.6, decimals: 1, current: 0, suffix: '%' },
    { label: 'Top GCSE Score', target: 99.5, decimals: 1, current: 0, suffix: '%' }
  ];

  constructor(private elRef: ElementRef) { }

  ngOnInit(): void {
    this.tsrLoadFonts();
    this.tsrMarqueeItems = this.tsrSchools.slice(0, 50);
    this.tsrApplyFilters();
  }

  ngAfterViewInit(): void {
    this.tsrSetupScrollReveal();
    this.tsrRunCountUp();
  }

  tsrLoadFonts(): void {
    var fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,400;0,600;0,700;0,800;0,900;1,700&display=swap';
    document.head.appendChild(fontLink);

    var iconLink = document.createElement('link');
    iconLink.rel = 'stylesheet';
    iconLink.href = 'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css';
    document.head.appendChild(iconLink);
  }

  tsrGenderLabel(gender: string): string {
    return gender.charAt(0).toUpperCase() + gender.slice(1);
  }

  // ===== filter / sort / paginate =====
  tsrSetGender(gender: string): void {
    this.tsrGender = gender;
    this.tsrPage = 1;
    this.tsrApplyFilters();
  }

  tsrOnSearchChange(value: string): void {
    this.tsrSearch = value;
    this.tsrPage = 1;
    this.tsrApplyFilters();
  }

  tsrSort(key: string): void {
    if (this.tsrSortKey === key) {
      this.tsrSortDir = this.tsrSortDir * -1;
    } else {
      this.tsrSortKey = key;
      this.tsrSortDir = 1;
    }
    this.tsrApplyFilters();
  }

  tsrGoPage(page: number): void {
    if (page < 1 || page > this.tsrTotalPages) { return; }
    this.tsrPage = page;
    this.tsrUpdatePageRows();
  }

  tsrApplyFilters(): void {
    var search = this.tsrSearch.toLowerCase();
    var gender = this.tsrGender;
    var rows = this.tsrSchools.filter(function (r) {
      var haystack = (r.name + ' ' + r.loc).toLowerCase();
      var matchesSearch = haystack.indexOf(search) !== -1;
      var matchesGender = gender === 'all' ? true : r.gender === gender;
      return matchesSearch && matchesGender;
    });

    var sortKey = this.tsrSortKey;
    var sortDir = this.tsrSortDir;
    rows.sort(function (a: any, b: any) {
      var av = a[sortKey];
      var bv = b[sortKey];
      if (typeof av === 'string') { av = av.toLowerCase(); bv = bv.toLowerCase(); }
      if (av < bv) { return -1 * sortDir; }
      if (av > bv) { return 1 * sortDir; }
      return 0;
    });

    this.tsrFilteredRows = rows;
    this.tsrTotalPages = Math.max(1, Math.ceil(rows.length / this.tsrPageSize));
    if (this.tsrPage > this.tsrTotalPages) { this.tsrPage = this.tsrTotalPages; }
    this.tsrUpdatePageRows();
  }

  tsrUpdatePageRows(): void {
    var start = (this.tsrPage - 1) * this.tsrPageSize;
    this.tsrPageRows = this.tsrFilteredRows.slice(start, start + this.tsrPageSize);

    var pages: number[] = [];
    for (var p = 1; p <= this.tsrTotalPages; p++) {
      if (p === 1 || p === this.tsrTotalPages || Math.abs(p - this.tsrPage) <= 1) {
        pages.push(p);
      } else if (pages[pages.length - 1] !== 0) {
        pages.push(0); // 0 = ellipsis marker
      }
    }
    this.tsrPageNumbers = pages;
  }

  // ===== scroll reveal (no @HostListener; IntersectionObserver in ngOnInit/AfterViewInit) =====
  tsrSetupScrollReveal(): void {
    var self = this;
    var hostEl: HTMLElement = this.elRef.nativeElement;
    var cards = hostEl.querySelectorAll('.tsr-card');

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card: Element) {
        card.className = card.className + ' tsr-visible';
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var target = entry.target as HTMLElement;
          target.className = target.className + ' tsr-visible';
          var fills = target.querySelectorAll('.tsr-compare-fill');
          fills.forEach(function (fill: Element) {
            var el = fill as HTMLElement;
            var width = el.getAttribute('data-width');
            el.style.width = width + '%';
          });
          obs.unobserve(target);
        }
      });
    }, { threshold: 0.15 });

    cards.forEach(function (card: Element) {
      observer.observe(card);
    });
  }

  // ===== count-up hero stats =====
  tsrRunCountUp(): void {
    var self = this;
    self.tsrHeroStats.forEach(function (stat) {
      var steps = 40;
      var inc = stat.target / steps;
      var cur = 0;
      var timer = setInterval(function () {
        cur = cur + inc;
        if (cur >= stat.target) {
          cur = stat.target;
          clearInterval(timer);
        }
        stat.current = stat.decimals ? Math.round(cur * 10) / 10 : Math.round(cur);
      }, 30);
    });
  }
}
